/**
 * Created by oleturvoll on 22/5/17.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/filter';
import auth0 from 'auth0-js';
import {LoggerService} from './logger-service';
import {Auth0Vars} from '../auth0-variables';

@Injectable()
export class AuthService {

  //TODO take this from variables file
  auth0 = new auth0.WebAuth({
    clientID: Auth0Vars.AUTH0_CLIENT_ID,
    domain: Auth0Vars.AUTH0_DOMAIN,
    responseType: 'token id_token',
    audience: 'https://voltio.au.auth0.com/userinfo',
    redirectUri: 'https://staging.voltio.com.au/#/tabs/about/about',
    //redirectUri: 'http://localhost:8100/#/tabs/about/about',
    useHash: true,
    scope: 'openid'
  });

  constructor( public logger: LoggerService) {
    // let {router, logger} = parameters;
    this.logger.log.debug('Constructor');
    // this.logger.log.debug(router);
    // this.logger.log.debug(logger);
  }

  public login(): void {

    this.logger.log.debug('login: ');
    this.auth0.authorize();
  }

  //TODO: integrate with afAuth here.
  public handleAuthentication(): void {
    this.logger.log.debug('handleAuthentication');

    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        // window.location.hash = '';
        this.setSession(authResult);

        this.logger.log.debug('authenticated: ');
        this.logger.log.debug(authResult);
        this.logger.log.debug(authResult.accessToken);
        this.logger.log.debug(authResult.idToken);
        // this.navCtrl.push( AboutPage);
      } else if (err) {
        this.logger.log.debug('error: ' + err);
        // this.navCtrl.push( SupportPage);
        this.logger.log.debug(err);
      }
    });
  }

  private setSession(authResult): void {

    this.logger.log.debug('setSession');
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);

    this.logger.log.debug('set session');
    this.logger.log.debug(authResult.accessToken);
    this.logger.log.debug(authResult.idToken);
    this.logger.log.debug(expiresAt);

  }

  public logout(): void {

    this.logger.log.debug('logout');
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // Go back to the home route
    // this.navCtrl.push( LoginPage );
    this.logger.log.debug('logout');
  }

  public isAuthenticated(): boolean {

    this.logger.log.debug('isAuthenticated');
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

}

/**
 * http://localhost:4200/callback#access_token=GxQpXbxQheBRWMnP&expires_in=720…crAS3CVH5fCJPX6gCN3aMqlZYdHmv3F5w_Y_rLiRP0759_RhBotfzyKWNzWSxXHbaV4_izUw:1 GET http://localhost:4200/callback
 */



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts